import { inject, Injectable } from "@angular/core";
import { ServerEventsService } from "../services/server-events.service";
import { maintenance } from "src/app/support/maintenance";
import { ErrorCodes } from "src/app/modules/maintenance/error-codes";
import { Router } from "@angular/router";
import { sntLog } from "src/app/common/logger";
import { PRODUCT_TOKEN } from "src/app/core/product.token";
import { SoftwareProduct } from "src/app/support/product";
import { environment } from "src/environments/environment";
import { AuthService } from "src/app/services/auth.service";

const logger = sntLog("EnableServerEventsGuard");

@Injectable()
export class EnableServerEventsGuard {
  readonly #serverEventsService = inject(ServerEventsService);
  readonly #router = inject(Router);
  readonly #product = inject(PRODUCT_TOKEN);
  readonly #authService = inject(AuthService);

  async canActivate(): Promise<boolean> {
    // TODO rimuovere in attesa del rafactoring che sposta le guardie si Snootas nel
    // dominio dedicato
    // l'iniziallizzazione di SSE in botmaster viene fatta nel modulo del dominio
    if (this.#product === SoftwareProduct.BOTMASTER) {
      return true;
    }

    logger.debug("canActivate");

    try {
      this.#serverEventsService.start({
        headersFactory: async () => {
          const [authorizationToken, memberToken] = await Promise.all([
            this.#authService.getAuthorizationBearerToken(),
            this.#authService.getMemberBearerToken(false)
          ]);

          return {
            Authorization: authorizationToken!,
            Member: memberToken!
          };
        },
        endpointFactory: () =>
          Promise.resolve(environment.snoots.serverEvents.endpoint)
      });
      logger.debug(`activated`);
      return true;
    } catch (ex) {
      logger.error(ex);
      maintenance(this.#router, {
        code: ErrorCodes.ERR_015
      });
      return false;
    }
  }
}
